/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GrantPromoCampaignManagerOptions,
  GrantPromoCampaignManagerResponses,
} from '../types/GrantPromoCampaignManager'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN only. Idempotent PUT with no body. QR campaign grants are independent of home tenant and affiliate programs. Removal takes effect on the next protected request after commit; already authorized reads/downloads may finish. Batch issuance and removal serialize on the campaign lock.
 * @summary Grant QR campaign access for an Affiliate Manager
 * {@link /v1/promo_campaigns/:trading_challenge_id/managers/:manager_id}
 */
export function grantPromoCampaignManager<ThrowOnError extends boolean = true>(
  options: Options<GrantPromoCampaignManagerOptions, ThrowOnError>,
): Unwrappable<RequestResult<GrantPromoCampaignManagerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/promo_campaigns/{trading_challenge_id}/managers/{manager_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GrantPromoCampaignManagerResponses, ThrowOnError>>,
  )
}
